import { jsx as s } from "react/jsx-runtime";
import n from "react";
import m, { css as c } from "styled-components";
const d = m.img.withConfig({
  displayName: "Image",
  componentId: "sc-1nxfpu5-0"
})(["display:inline-block;border-radius:var(--default-border-radius);width:100%;height:100%;object-fit:cover;object-position:50% 50%;", ""], ({
  $aspectRatio: t
}) => t && c(["aspect-ratio:", ";"], g(t))), g = (t) => {
  const a = t.split(":");
  return Number(a[0]) / Number(a[1]);
}, e = {
  "1:1": "1:1",
  "3:2": "3:2"
};
Object.values(e);
const p = n.forwardRef(({
  src: t = "",
  alt: a = "",
  aspectRatio: o = e["1:1"],
  ...r
}, i) => /* @__PURE__ */ s(d, { ...r, alt: a, src: t, $aspectRatio: o, ref: i, "data-testid": "rango-image", "data-rango-component": "rango-image", "data-is-rango": !0 }));
p.displayName = "RangoImage";
export {
  e as ImageAspectRatio,
  p as RangoImage
};
